<template>
    <div class="app">
        <FAlert></FAlert>
        <FConfirm></FConfirm>
        <sidelink></sidelink>
        <Apply></Apply>
        <top></top>
        <home-link-nav></home-link-nav>
        <router-view></router-view>
        <Foot></Foot>
    </div>
</template>

<script>
    import top from './components/top'
    import HomeLinkNav from './components/home-link-nav'
    import Foot from './components/foot'
    import Apply from './components/apply'
    import sidelink from './components/sidelink'
    import FAlert from '../../components/FAlert'
    import FConfirm from '../../components/FConfirm'
    export default {
        name: "app",
        metaInfo: {
            title: '福分通-平台首页', // set a title
            meta: [{                 // set meta
                name: '福分通',
                content: '专注企业员工福利'
            }]
        },
        components: {
            top,
            HomeLinkNav,
            Foot,
            Apply,
            sidelink,
            FAlert,FConfirm
        }
    }
</script>

<style scoped lang="stylus">
    .app
        position relative
        padding-top 640px
</style>